export function empresasveiculosInRequest(params = {}) {
  return {
    type: '@empresasveiculo/EMPRESASVEICULOS_IN_REQUEST',
    payload: { params },
  };
}

export function findEmpresasVeiculo(idempresaveiculo) {
  return {
    type: '@empresasveiculo/FIND_EMPRESASVEICULO',
    payload: { idempresaveiculo },
  };
}

export function failedRequest() {
  return {
    type: '@empresasveiculo/FAILED_REQUEST',
  };
}

export function deleteEmpresasVeiculo(idempresaveiculo, params) {
  return {
    type: '@empresasveiculo/DELETE_EMPRESASVEICULO',
    payload: { idempresaveiculo, params },
  };
}

export function updateEmpresasVeiculo(empresasveiculo, params) {
  return {
    type: '@empresasveiculo/UPDATE_EMPRESASVEICULO',
    payload: { empresasveiculo, params },
  };
}

export function storeEmpresasVeiculo(empresasveiculo, params) {
  return {
    type: '@empresasveiculo/STORE_EMPRESASVEICULO',
    payload: { empresasveiculo, params },
  };
}

export function successInRequest(
  empresasveiculos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@empresasveiculo/SUCCESS_IN_REQUEST',
    payload: { empresasveiculos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(empresasveiculo) {
  return {
    type: '@empresasveiculo/SUCCESS_REQUEST',
    payload: { empresasveiculo },
  };
}

export function successRemove(params) {
  return {
    type: '@empresasveiculo/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@empresasveiculo/RECORD_FILTERING',
    payload: { params },
  };
}
